import { createContext } from 'react'
//Invoice details
const invoiceContext = createContext()

export default invoiceContext
